// Lookup-object-driven chips for the PROXY section — mirrors StatusPill.tsx's
// "status → CSS class" pattern rather than inline hex everywhere.
import React from 'react';
import type { ProxyBand } from '../../data/mockProxyJobs';
import { ACTION_LABEL, type ProxyAction, type DecisionResult } from '../../utils/proxyDecisioning';

const BAND_CLASS: Record<ProxyBand, string> = { Red: 'band-red', Yellow: 'band-yellow', Green: 'band-green' };

export function BandChip({ band }: { band: ProxyBand }) {
  return <span className={`sp text-xs whitespace-nowrap ${BAND_CLASS[band]}`}>{band}</span>;
}

const ACTION_CLASS: Record<ProxyAction, string> = {
  FOLLOW_UP: 'ra-followup',
  PULL_FILING: 'ra-pullfiling',
  POD: 'ra-pod',
  EMAIL_ONLY_CANCEL_FULLSETS: 'ra-cancel',
  ABORT: 'ra-abort',
  HOLD_MAIL_DATE: 'ra-hold',
  HOLD_DISCOVERY: 'ra-hold',
  NO_ACTION: 'ra-noaction',
};

export function RecommendedActionChip({ decision }: { decision: DecisionResult }) {
  return (
    <span className="inline-flex items-center gap-1.5">
      <span className={`tp ${ACTION_CLASS[decision.action]}`} title={decision.reason}>
        {ACTION_LABEL[decision.action]}
      </span>
      {decision.outsideGuidelines && (
        <span className="tp ra-cancel" title="Outside standard guidelines. This is for information only and isn't blocked.">
          Escalate to manager
        </span>
      )}
    </span>
  );
}

export function StaleOutreachChip({ label = 'No outreach today' }: { label?: string }) {
  return <span className="tp ra-cancel">{label}</span>;
}

export function BroadridgeChip() {
  return <span className="tp ra-hold" title="Use the RICS portal, not email.">Broadridge: use RICS</span>;
}

export function CanadianHoldChip({ mailDate }: { mailDate: string }) {
  return <span className="tp ra-hold" title="Canadian intermediary mail date hasn't passed yet.">Mail date {mailDate}, don't follow up yet</span>;
}

export function VifBreOnlyChip() {
  return <span className="tp ra-hold">VIF/BRE Only</span>;
}

export function MediantCcChip() {
  return <span className="tp ra-hold" title="Copies brokersearch@ and the team named in the MIC ops note.">Mediant: extra CCs added</span>;
}

export function DoNotFollowUpChip() {
  return <span className="tp ra-abort">ICT DO NOT FOLLOW UP</span>;
}
